import React from 'react';
import { Info as LucideInfo, User as LucideUser, Eye as LucideEye, EyeOff as LucideEyeOff, ChevronUp as LucideChevronUp, ChevronDown as LucideChevronDown, Trash2 as LucideTrash2, ShieldCheck as LucideShieldCheck, Check as LucideCheck, AlertTriangle as LucideAlertTriangle, X as LucideX, MessageCircle as LucideMessageCircle, CheckCircle as LucideCheckCircle, Calendar as LucideCalendar, Lock as LucideLock, Users as LucideUsers, Globe as LucideGlobe, RefreshCw as LucideRefreshCw, Plus as LucidePlus, Minus as LucideMinus, ArrowUp as LucideArrowUp, ArrowDown as LucideArrowDown, Send as LucideSend, Star as LucideStar, LoaderCircle as LucideLoaderCircle, UserPlus as LucideUserPlus, PaintBucket as LucidePaintBucket, Moon as LucideMoon, Camera as LucideCamera, ShoppingCart as LucideShoppingCart, ChevronLeft as LucideChevronLeft, ChevronRight as LucideChevronRight, AlertCircle as LucideAlertCircle, Upload as LucideUpload, Menu as LucideMenu, MoreHorizontal as LucideMoreHorizontal, Search as LucideSearch, Share2 as LucideShare2, Grid2X2 as LucideGrid2x2, Clock as LucideClock, MapPin as LucideMapPin, File as LucideFile, Monitor as LucideMonitor, Smartphone as LucideSmartphone, GitBranch as LucideGitBranch, UserMinus as LucideUserMinus, Gift as LucideGift, Edit as LucideEdit, ChevronUp as LucideChevronUp2, ChevronDown as LucideChevronDown2, Settings as LucideSettings, LogOut as LucideLogOut, LogIn as LucideLogIn, Flame as LucideFlame, Filter as LucideFilter } from 'lucide-react';

// Map commonly used icon names in the app to lucide-react equivalents
export const Info = (p) => <LucideInfo {...p} />;
export const InfoOutlined = (p) => <LucideInfo {...p} />;
export const Person = (p) => <LucideUser {...p} />;
export const UserOutlined = (p) => <LucideUser {...p} />;
export const Visibility = (p) => <LucideEye {...p} />;
export const VisibilityOff = (p) => <LucideEyeOff {...p} />;
export const EyeInvisibleOutlined = (p) => <LucideEyeOff {...p} />;
export const ExpandLess = (p) => <LucideChevronUp {...p} />;
export const ExpandMore = (p) => <LucideChevronDown {...p} />;
export const DeleteOutline = (p) => <LucideTrash2 {...p} />;
export const VerifiedUser = (p) => <LucideShieldCheck {...p} />;
export const Check = (p) => <LucideCheck {...p} />;
export const Done = (p) => <LucideCheck {...p} />;
export const CheckOutlined = (p) => <LucideCheck {...p} />;
export const WarningAmberRounded = (p) => <LucideAlertTriangle {...p} />;
export const Close = (p) => <LucideX {...p} />;
export const CloseOutlined = (p) => <LucideX {...p} />;
export const CloseCircleOutlined = (p) => <LucideX {...p} />;
export const CloseCircleFilled = (p) => <LucideX {...p} />;
export const ChatBubble = (p) => <LucideMessageCircle {...p} />;
export const CheckCircle = (p) => <LucideCheckCircle {...p} />;
export const CheckCircleOutlined = (p) => <LucideCheckCircle {...p} />;
export const CalendarMonthIcon = (p) => <LucideCalendar {...p} />;
export const CalendarMonth = (p) => <LucideCalendar {...p} />;
export const Lock = (p) => <LucideLock {...p} />;
export const LockOutlined = (p) => <LucideLock {...p} />;
export const People = (p) => <LucideUsers {...p} />;
export const TeamOutlined = (p) => <LucideUsers {...p} />;
export const Public = (p) => <LucideGlobe {...p} />;
export const GlobalOutlined = (p) => <LucideGlobe {...p} />;
export const LoopOutlined = (p) => <LucideRefreshCw {...p} />;
export const ReloadOutlined = (p) => <LucideRefreshCw {...p} />;
export const Add = (p) => <LucidePlus {...p} />;
export const Remove = (p) => <LucideMinus {...p} />;
export const ArrowDropUp = (p) => <LucideArrowUp {...p} />;
export const ArrowDropDown = (p) => <LucideArrowDown {...p} />;
export const ArrowLeftOutlined = (p) => <LucideChevronLeft {...p} />;
export const ArrowRightOutlined = (p) => <LucideChevronRight {...p} />;
export const Send = (p) => <LucideSend {...p} />;
export const SendOutlined = (p) => <LucideSend {...p} />;
export const Interests = (p) => <LucideStar {...p} />;
export const LoadingOutlined = (p) => <LucideLoaderCircle {...p} />;
export const PersonAdd = (p) => <LucideUserPlus {...p} />;
export const FormatColorFillOutlined = (p) => <LucidePaintBucket {...p} />;
export const DarkMode = (p) => <LucideMoon {...p} />;
export const MoonOutlined = (p) => <LucideMoon {...p} />;
export const CameraAlt = (p) => <LucideCamera {...p} />;
export const CameraFilled = (p) => <LucideCamera {...p} />;
export const ShoppingOutlined = (p) => <LucideShoppingCart {...p} />;
export const ShopOutlined = (p) => <LucideShoppingCart {...p} />;
export const LeftOutlined = (p) => <LucideChevronLeft {...p} />;
export const RightOutlined = (p) => <LucideChevronRight {...p} />;
export const ExclamationCircleOutlined = (p) => <LucideAlertCircle {...p} />;
export const UploadOutlined = (p) => <LucideUpload {...p} />;
export const MenuOutlined = (p) => <LucideMenu {...p} />;
export const MoreOutlined = (p) => <LucideMoreHorizontal {...p} />;
export const SearchOutlined = (p) => <LucideSearch {...p} />;
export const ShareAltOutlined = (p) => <LucideShare2 {...p} />;
export const AppstoreOutlined = (p) => <LucideGrid2x2 {...p} />;
export const ClockCircleOutlined = (p) => <LucideClock {...p} />;
export const EnvironmentOutlined = (p) => <LucideMapPin {...p} />;
export const FileOutlined = (p) => <LucideFile {...p} />;
export const DesktopOutlined = (p) => <LucideMonitor {...p} />;
export const MobileOutlined = (p) => <LucideSmartphone {...p} />;
export const BranchesOutlined = (p) => <LucideGitBranch {...p} />;
export const UserDeleteOutlined = (p) => <LucideUserMinus {...p} />;
export const UserAddOutlined = (p) => <LucideUserPlus {...p} />;
export const UsergroupAddOutlined = (p) => <LucideUserPlus {...p} />;
export const EyeOutlined = (p) => <LucideEye {...p} />;
export const InfoCircleOutlined = (p) => <LucideInfo {...p} />;
export const DeleteOutlined = (p) => <LucideTrash2 {...p} />;
export const PlusOutlined = (p) => <LucidePlus {...p} />;
export const MinusOutlined = (p) => <LucideMinus {...p} />;
export const DownOutlined = (p) => <LucideChevronDown {...p} />;
export const UpOutlined = (p) => <LucideChevronUp {...p} />;
export const CaretDownOutlined = (p) => <LucideChevronDown {...p} />;
export const RightOutlinedIcon = (p) => <LucideChevronRight {...p} />;
export const StarFilled = (p) => <LucideStar {...p} />;
export const StarOutlined = (p) => <LucideStar {...p} />;
export const HeartFilled = (p) => <LucideStar {...p} />;
export const HeartOutlined = (p) => <LucideStar {...p} />;
export const GiftOutlined = (p) => <LucideGift {...p} />;
export const EditOutlined = (p) => <LucideEdit {...p} />;
export const EditFilled = (p) => <LucideEdit {...p} />;
export const SettingOutlined = (p) => <LucideSettings {...p} />;
export const LogoutOutlined = (p) => <LucideLogOut {...p} />;
export const LoginOutlined = (p) => <LucideLogIn {...p} />;
export const FireOutlined = (p) => <LucideFlame {...p} />;
export const FilterOutlined = (p) => <LucideFilter {...p} />;

export { MetallicIcon as Metallic } from './MetallicIcon';
